import React from "react";
import { ArrowRight, Stethoscope, ChevronRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const physicians = [{
  name: "Dr. Bronius Špakauskas",
  specialty: "Senior Neurosurgeon",
  image: "",
  bio: "Leading expert in complex spinal reconstructions and neurosurgical interventions for Irish patients."
}, {
  name: "Dr. Giedrius Bernotavičius",
  specialty: "Spine Surgery Expert",
  image: "",
  bio: "Specializes in minimally invasive spine surgery and advanced neurological treatments in Kaunas."
}, {
  name: "Dr. Arūnas Ščiupokas",
  specialty: "Pain Management Specialist",
  image: "",
  bio: "Expert in interventional pain management and non-surgical relief for chronic spinal conditions."
}, {
  name: "Dr. Tomas Sveikata",
  specialty: "Orthopedic Surgeon",
  image: "",
  bio: "Dedicated to joint preservation and surgical solutions for mobility-impaired patients."
}, {
  name: "Dr. Justinas Špakauskas",
  specialty: "Neurosurgical Specialist",
  image: "",
  bio: "Focused on the latest neurosurgical techniques and patient-centered recovery protocols."
}, {
  name: "Inga Špakauskienė",
  specialty: "Senior Physiotherapist",
  image: "",
  bio: "Expert in post-operative rehabilitation, helping patients regain strength after spine surgery."
}, {
  name: "Laura Petruškevičiūtė",
  specialty: "Rehabilitation Lead",
  image: "",
  bio: "Specializes in intensive physical therapy and personalized recovery plans for mobility."
}];
export default function ClinicalLeadership() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return;
}